import type { paymentsApiSpec } from "@wingspanhq/wingspan-api-types";
import { WSService } from "../../../../utils/WSService";

const service = new WSService("/v2/payments/payables");

export const listPayableBulkActionBatches = async (
  request?: paymentsApiSpec.operations["listPayableBulkActionBatches"]["parameters"]["query"]
): Promise<paymentsApiSpec.PayableBulkActionBatch[]> => {
  const { data } = await service.get("/bulk-action", { params: request });
  return data as paymentsApiSpec.PayableBulkActionBatch[];
};
